export const DEV_SERVER = "http://localhost:8000";
export const DEV_SERVER_SSL = "https://localhost";
export const PRD_SERVER = "https://sc.kurdi.krd";
export const ACTIVE_SERVER = PRD_SERVER;
export const BULK_SPELL_CHECK_ENDPOINT = ACTIVE_SERVER + "/api/bulk-spell-check/";
export const SUGGESTION_LIMIT_DEFAULT = 3
